module.exports = __webpack_public_path__ + "static/media/tourist-ra3oAd6hrnM.9355b9ff.png";